import { Button, Checkbox, DestructiveIcon, Flex, Label } from '@modusign/design-system';
import { ReactNode } from 'react';

import {
  FullWidthButtonModal,
  FullWidthButtonModalContent,
  FullWidthButtonModalFooter,
  FullWidthButtonModalTitle,
} from '@app/components/Modal/FullWidthButtonModal';

interface FullWidthButtonAlertModalWithCheckboxProps {
  isOpen: boolean;
  title: string;
  confirmButtonLabel: string;
  cancelButtonLabel: string;
  checkBoxLabel: string;
  children: ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  onCheckBoxChange: (value: boolean) => void;
}

export function FullWidthButtonAlertModalWithCheckbox({
  isOpen,
  title,
  confirmButtonLabel,
  cancelButtonLabel,
  checkBoxLabel,
  children,
  onClose,
  onConfirm,
  onCancel,
  onCheckBoxChange,
}: FullWidthButtonAlertModalWithCheckboxProps) {
  return (
    <FullWidthButtonModal isOpen={isOpen} maxWidth="xs" width="100%" onClose={onClose}>
      <FullWidthButtonModalTitle onClose={onClose}>
        <DestructiveIcon color="iconPrimaryBase" mr={1} /> {title}
      </FullWidthButtonModalTitle>
      <FullWidthButtonModalContent>{children}</FullWidthButtonModalContent>
      <FullWidthButtonModalFooter>
        <Button variant="primary" onClick={onConfirm}>
          {confirmButtonLabel}
        </Button>
        <Button variant="basic" onClick={onCancel}>
          {cancelButtonLabel}
        </Button>
        <Flex alignItems="center" justifyContent="center" mt={3}>
          <Checkbox
            defaultChecked={false}
            id="alert-modal-checkbox"
            onChange={(e) => onCheckBoxChange(e.currentTarget.checked)}
          />
          <Label
            htmlFor="alert-modal-checkbox"
            mb={0}
            ml={2}
            sx={{
              cursor: 'pointer',
            }}
          >
            {checkBoxLabel}
          </Label>
        </Flex>
      </FullWidthButtonModalFooter>
    </FullWidthButtonModal>
  );
}
